import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/quality-thresholds`;

export const qualityThresholdService = {
  listAll: async () => {
    const response = await axios.get(API_BASE);
    return response.data;
  },

  getByType: async (sourceType) => {
    const response = await axios.get(`${API_BASE}/${sourceType}`);
    return response.data;
  },

  configure: async (sourceType, data) => {
    const response = await axios.put(`${API_BASE}/${sourceType}`, data);
    return response.data;
  },

  reset: async (sourceType) => {
    const response = await axios.delete(`${API_BASE}/${sourceType}`);
    return response.data;
  },

  evaluate: async (fileId, mappingTemplateId) => {
    const response = await axios.post(`${API_BASE}/evaluate`, {
      file_id: fileId,
      mapping_template_id: mappingTemplateId
    });
    return response.data;
  },

  evaluateBatch: async (fileIds) => {
    const response = await axios.post(`${API_BASE}/evaluate-batch`, { file_ids: fileIds });
    return response.data;
  },

  getBreakdown: async (fileId) => {
    const response = await axios.get(`${API_BASE}/breakdown/${fileId}`);
    return response.data;
  }
};

export default qualityThresholdService;
